import { generateRecurrentOrders } from '@/features/domain/order'
import { useCreateFormatDate, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { useCallback } from 'react'
import { CustomNotification } from '../components/CustomNotification'
import { useTexts } from './useTexts'

export function useRestoreOrders() {
  const formatDate = useCreateFormatDate()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const texts = useTexts()

  const restoreOrders = useCallback(async () => {
    try {
      const result = await dispatch(generateRecurrentOrders())

      if (!generateRecurrentOrders.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      // Check if it's a partial restore
      if (result.payload?.orderLimitReached) {
        toast.warning(CustomNotification, {
          data: {
            title: texts.customNotificationTitle,
            formattedDate: result.payload.lastDate ? formatDate(result.payload.lastDate, true) : '',
          },
        })
      } else {
        toast.success(texts.restoreOrdersSuccess)
      }

      return result.payload
    } catch (error) {
      toast.error(error.message)
      console.error('Failed to restore orders:', error)
    }
  }, [dispatch, toast, texts, formatDate])

  return {
    restoreOrders,
  }
}
